namespace GeniuzPOS.Inventory {
    export interface IcStockSoldRow {
        Id?: number;
        SysDocNo?: string;
        DocNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        StockTo?: string;
        CustName?: string;
        WhsId?: string;
        WhsName?: string;
        Remark?: string;
        PostFg?: PostFgStatus;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
        SoldDtList?: IcStockSoldDtRow[];
        CancelFg?: CancelFgstatus;
    }

    export namespace IcStockSoldRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Inventory.IcStockSold';
        export const lookupKey = 'Inventory.IcStockSold';

        export function getLookup(): Q.Lookup<IcStockSoldRow> {
            return Q.getLookup<IcStockSoldRow>('Inventory.IcStockSold');
        }
        export const deletePermission = '2Inventory:รายการ:เบิกขาย:Modify';
        export const insertPermission = '2Inventory:รายการ:เบิกขาย:Modify';
        export const readPermission = '2Inventory:รายการ:เบิกขาย:View';
        export const updatePermission = '2Inventory:รายการ:เบิกขาย:Modify';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            DocNo = "DocNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            StockTo = "StockTo",
            CustName = "CustName",
            WhsId = "WhsId",
            WhsName = "WhsName",
            Remark = "Remark",
            PostFg = "PostFg",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate",
            SoldDtList = "SoldDtList",
            CancelFg = "CancelFg"
        }
    }
}
